<template>
  <div class="add-evaluation-page">
    <common-title
      titleName="评价"
      v-if="!isMiniProgram"
      :bcColor="'#FEFEFF'"
      :zIndex="1000"
    ></common-title>
    <div class="rate-div">
      <van-rate
        v-model="rateValue"
        :size="40"
        :icon="require('../../../assets/img/learningGuidePage/star.png')"
        :void-icon="require('../../../assets/img/learningGuidePage/void_star.png')"
      />
    </div>
    <textarea v-model="evaluation" maxlength="100" placeholder="请输入评价" />
    <span class="evaluation-count">{{ evaluation.length }}/100</span>
    <footer>
      <commonButton :value="btnInfo" @click="submit" :loading="submitting" />
    </footer>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import commonButton from '@/components/commonComponents/commonButton';
import { reqProductEvaluation } from '@/api/learningGuidePage';
// eslint-disable-next-line import/extensions
import CommonTitle from '@/components/header/CommonTitle';

export default {
  components: { commonButton, CommonTitle },
  props: {
    isMiniProgram: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rateValue: 0,
      evaluation: '',
      btnInfo: {
        text: '提交',
        loading: false,
        disabled: false,
      },
      productDetail: {},
      submitting: false,
    };
  },
  mounted() {},
  methods: {
    submit() {
      if (this.submitting) {
        return;
      }
      if (!this.rateValue) {
        this.$toast('请选择评价等级！');
        return;
      }
      if (!this.evaluation) {
        this.$toast('请输入评价内容！');
        return;
      }
      this.submitting = true;
      const { courseId, teacherId, entryType } = this.$route.query;
      const param = {
        entryType: entryType || 1,
        evaluationContent: this.evaluation,
        evaluationStar: this.rateValue,
        productId: courseId,
      };
      if (Number(entryType) === 3) {
        param.teacherId = teacherId;
      }
      reqProductEvaluation(param)
        .then((res) => {
          if (res.code === 0) {
            this.$toast('评价成功');
            setTimeout(() => {
              this.$parent.$data.isAddEvaluation = false;
            }, 1000);
          } else {
            this.$toast(res.msg || '评价失败');
          }
          this.submitting = false;
        })
        .catch(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.add-evaluation-page {
  .rate-div {
    width: 100%;
    padding-top: 87px;
    text-align: center;

    img {
      width: 72px;
    }
  }

  textarea {
    width: calc(100% - 112px);
    height: 420px;
    margin-top: 87px;
    margin-left: 36px;
    padding: 20px;
    font-size: 32px;
    line-height: 46px;
    word-break: break-all;
    border-color: #eee;
    border-radius: 14px;
    outline: none;
    -webkit-appearance: none;
    resize: none;
  }

  .evaluation-count {
    display: block;
    width: 100%;
    padding-right: 36px;
    color: #787878;
    font-size: 28px;
    line-height: 36px;
    text-align: right;
  }

  footer {
    width: calc(100% - 116px);
    margin-top: 50px;
    margin-left: 58px;
  }

  ::v-deep .van-rate__item:not(:last-child) {
    margin-right: 16px;
  }
}
</style>
